import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ManagementApiService } from 'src/app/services';
import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SecurityRoleService } from 'src/app/services/security-role.service';
import { Subscription } from 'rxjs';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PermissionHierarchy } from 'src/app/Modules/management/models/organization/security-role-permission.model';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
@Component({
    selector: 'app-user-type-permission-modal',
    templateUrl: './user-type-permission-modal.component.html',
    styleUrls: ['./user-type-permission-modal.component.scss'],
})
export class UserTypePermissionModalComponent implements OnInit, OnDestroy {
    @Input() modalMode: string;
    @Input() securityRoleName: string;
    @Input() securityRoleDescription: string;
    @Input() index: number;
    @Input() permissionTreeData: any;

    @ViewChild('treeToggleBtn') treeToggleBtn: ElementRef;
    @ViewChild('roleName') roleName: ElementRef;
    @ViewChild('description') description: ElementRef;

    roleForm: UntypedFormGroup;
    checked = false;
    tempIndex: any;
    availableSecurityRoleList: PermissionHierarchy[];
    securityRoleSubscription: Subscription;
    displayedColumns: string[] = ['permission name', 'Create', 'write', 'View', 'Delete'];
    treeData: any;
    isRoleNameChange: boolean;
    isDisable: boolean = false;
    checklistSelection = new SelectionModel<PermissionHierarchy>(true);
    checklistSelectionModify = new SelectionModel<PermissionHierarchy>(true);
    checklistSelectionView = new SelectionModel<PermissionHierarchy>(true);
    checkListSelectionDelete = new SelectionModel<PermissionHierarchy>(true);

    // if we want to add the new property to individual node then add it to transformer
    private transformer = (node: any, level: number) => {
        return {
            expandable: !!node.children && node.children.length > 0,
            name: node.name,
            actions: node.actions,
            level: level,
            children: node.children,
            securityPermissionRowId: node.securityPermissionRowId,
        };
    };

    treeControl = new FlatTreeControl<any>(
        (node) => node.level,
        (node) => node.expandable
    );

    treeFlattener = new MatTreeFlattener(
        this.transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.children
    );

    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    constructor(
        private cd: ChangeDetectorRef,
        private ngbActiveModal: NgbActiveModal,
        public managementApiService: ManagementApiService,
        private securityRoleService: SecurityRoleService,
        private customToastServiceService: CustomToastService,
        fb: UntypedFormBuilder,
        private customValidator: CustomValidatorService,
    ) {
        this.roleForm = fb.group({
            roleName: [[{ value: this.securityRoleName, disabled: true }], Validators.required],
        });
    }

    ngOnInit(): void {
        // this.permissionTreeData.securityRolePermissions[0].children = this.flattenChildren(this.permissionTreeData.securityRolePermissions[0].children);
        this.isRoleNameChange = false;
        this.securityRoleSubscription = this.securityRoleService.securityRoleList.subscribe((securityRoles) => {
            this.availableSecurityRoleList = securityRoles;
        });
        if (this.modalMode === 'edit' || this.modalMode === 'add') {
            this.dataSource.data = this.permissionTreeData.securityRolePermissions;
            this.initialSelectionForAllColumnsCheckList();
        } else if (this.modalMode === 'copy') {
            this.isRoleNameChange = true;
            this.dataSource.data = this.permissionTreeData.securityRolePermissions;
            this.initialSelectionForAllColumnsCheckList();
        } else if (this.modalMode === 'view') {
            this.roleForm.controls['roleName'].disable();
            this.isDisable = true;
            this.dataSource.data = this.permissionTreeData.securityRolePermissions;
            this.initialSelectionForAllColumnsCheckList();
            this.cd.detectChanges();
        } else {
            this.dataSource.data = this.permissionTreeData;
            this.permissionTreeData.name = this.securityRoleName;
        }
    }

    // * helper method to expand the tree
    toggleData(data) {
        for (let x = 0; x < this.treeControl.dataNodes.length; x++) {
            if (data.name !== this.treeControl.dataNodes[x].name && data.level == 0) {
                this.treeControl.collapse(this.treeControl.dataNodes[x]);
            }
        }
        this.treeControl.toggle(data);
    }

    checkAllChildrenNode(data: any, status: boolean, columnName: string) {
        if (data.children?.length > 0) {
            for (let x = 0; x < data.children.length; x++) {
                if (data.children[x].actions[0].securityPermissionColumn.name === columnName && this.checkColumnExist('Create', data.children[x].actions)) {
                    data.children[x].actions[0].allowed = status;
                    if (data.children[x]?.children?.length > 0) {
                        this.checkAllChildrenNode(data.children[x], status, columnName);
                    }
                }
            }
        }
    }

    findAction(actions: any[], column) {
        let selectedActions;
        for (let x = 0; x < actions.length; x++) {
            if (actions[x].securityPermissionColumn.name === column) {
                selectedActions = actions;
            }
        }
        return selectedActions;
    }

    public checkColumnExist(column, actions) {
        return actions.some((item) => {
            return item.securityPermissionColumn.name === column;
        });
    }

    closeModalWithChanges() {
        if (this.checkDuplicateName(this.permissionTreeData.name) && this.isRoleNameChange) {
            this.customToastServiceService.errorToast('Security Role name already exist', 'Error');
        } else {
            if (this.modalMode === 'edit') {
                this.ngbActiveModal.close(this.permissionTreeData);
            } else if (this.modalMode === 'add') {
                let securityRoleName = this.permissionTreeData.name;
                let securityRoleDescription = this.permissionTreeData.description;
                let treeObject = {
                    name: securityRoleName,
                    description: securityRoleDescription,
                    securityRolePermissions: this.permissionTreeData.securityRolePermissions,
                    //securityRolePermissions: [this.permissionTreeData[0]],
                    isDerivedFromTemplate: false,
                    isMandatory: false,
                    isSysAdmin: false,
                };
                this.ngbActiveModal.close(treeObject);
            } else {
                let securityRoleName = this.permissionTreeData.name;
                let securityRoleDescription = this.permissionTreeData.description;
                this.treeControl.dataNodes.forEach((element) => {
                    element.actions.forEach((element1) => {
                        delete element1.securityRolePermissionId;
                    });
                });
                let treeObject = {
                    name: securityRoleName,
                    description: securityRoleDescription,
                    securityRolePermissions: this.permissionTreeData.securityRolePermissions,
                    //securityRolePermissions: [this.permissionTreeData[0]],
                    isDerivedFromTemplate: false,
                    isMandatory: false,
                    isSysAdmin: false,
                };
                this.ngbActiveModal.close(treeObject);
            }
        }
    }

    closeModalWithCancel() {
        this.ngbActiveModal.close(false);
    }

    // helper method to check the name is not duplicate or not
    checkDuplicateName(securityRoleName: string) {
        for (const [index, securityRole] of this.availableSecurityRoleList.entries()) {
            if (securityRole.name === securityRoleName) {
                return true;
            }
        }
        return false;
    }

    // security role name change event
    checkIsNameChanged(event) {
        if (this.modalMode === 'edit') {
            if (event.target.value === this.securityRoleName) {
                this.isRoleNameChange = false;
            } else {
                this.isRoleNameChange = true;
            }
        } else {
            this.isRoleNameChange = true;
        }
    }

    initialSelectionForAllColumnsCheckList() {
        // Create column checkList
        this.treeControl.dataNodes.forEach((dataNode) => {
            dataNode.actions.forEach((action) => {
                if (action.securityPermissionColumn.name === 'Create' && action.allowed) {
                    this.checklistSelection.select(dataNode);
                }
            });
        });

        // view checkList
        this.treeControl.dataNodes.forEach((dataNode) => {
            dataNode.actions.forEach((action) => {
                if (action.securityPermissionColumn.name === 'View' && action.allowed) {
                    this.checklistSelectionView.select(dataNode);
                }
            });
        });

        // modify column checklist
        this.treeControl.dataNodes.forEach((dataNode) => {
            dataNode.actions.forEach((action) => {
                if (action.securityPermissionColumn.name === 'Modify' && action.allowed) {
                    this.checklistSelectionModify.select(dataNode);
                }
            });
        });

        // delete column checklist
        this.treeControl.dataNodes.forEach((dataNode) => {
            dataNode.actions.forEach((action) => {
                if (action.securityPermissionColumn.name === 'Delete' && action.allowed) {
                    this.checkListSelectionDelete.select(dataNode);
                }
            });
        });
    }

    /********************** Create Column Methods  *************************/
    descendantsAllSelectedCreateColumn(node: any): boolean {
        const descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('Create', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const descAllSelected =
            temp.length > 0 &&
            temp.every((child) => {
                return this.checklistSelection.isSelected(child);
            });
        return descAllSelected;
    }

    descendantsPartiallySelectedCreateColumn(node: any): boolean {
        var descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('Create', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const result = temp.some((child) => this.checklistSelection.isSelected(child));
        return result && !this.descendantsAllSelectedCreateColumn(node);
    }

    todoItemSelectionToggleCreateColumn(node: any, checkStatus: boolean): void {
        // const descendants = this.treeControl.getDescendants(node);
        this.checkAllChildrenNode(node, checkStatus, 'Create');
        // this.checklistSelection.toggle(node);
        // let temp = [];
        // for (let x = 0; x < descendants.length; x++) {
        //     let actions = descendants[x].actions;
        //     let flag = this.checkColumnExist('Create', actions);
        //     if (flag) {
        //         temp.push(descendants[x]);
        //     }
        // }
        // this.checklistSelection.isSelected(node) ? this.checklistSelection.select(...temp) : this.checklistSelection.deselect(...temp);

        // // Force update for the parent
        // descendants.forEach((child) => this.checklistSelection.isSelected(child));
        this.checkAllParentsSelectionCreateColumn(node);
    }

    todoLeafItemSelectionToggleCreateColumn(node: any): void {
        this.checklistSelection.toggle(node);
        // this.checkAllParentsSelectionCreateColumn(node);
    }

    checkAllParentsSelectionCreateColumn(node: any): void {
        let parent: any | null = this.getParentNodeCreateColumn(node);
        while (parent) {
            this.checkRootNodeSelectionCreateColumn(parent);
            parent = this.getParentNodeCreateColumn(parent);
        }
    }

    checkRootNodeSelectionCreateColumn(node: any): void {
        const nodeSelected = this.checklistSelection.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('Create', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const descAllSelected =
            temp.length > 0 &&
            temp.every((child) => {
                return this.checklistSelection.isSelected(child);
            });
        if (nodeSelected && !descAllSelected) {
            this.checklistSelection.deselect(node);
        } else if (!nodeSelected && descAllSelected) {
            this.checklistSelection.select(node);
        }
    }

    getParentNodeCreateColumn(node: any): any | null {
        const currentLevel = node.level;
        if (currentLevel < 1) {
            return null;
        }
        const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
        for (let i = startIndex; i >= 0; i--) {
            const currentNode = this.treeControl.dataNodes[i];

            if (currentNode.level < currentLevel) {
                return currentNode;
            }
        }
        return null;
    }

    /********************** View Column Methods  *************************/
    descendantsAllSelectedViewColumn(node: any): boolean {
        const descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('View', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const descAllSelected =
            temp.length > 0 &&
            temp.every((child) => {
                return this.checklistSelectionView.isSelected(child);
            });
        return descAllSelected;
    }

    descendantsPartiallySelectedViewColumn(node: any): boolean {
        var descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('View', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const result = temp.some((child) => this.checklistSelectionView.isSelected(child));
        return result && !this.descendantsAllSelectedViewColumn(node);
    }

    todoLeafItemSelectionToggleViewColumn(node: any): void {
        this.checklistSelectionView.toggle(node);
        //this.checkAllParentsSelectionViewColumn(node);
    }

    todoItemSelectionToggleViewColumn(node: any, checkStatus: boolean): void {
        // this.checkAllChildrenNodeView(node, checkStatus, 'View');
        this.checklistSelectionView.toggle(node);

        // const descendants = this.treeControl.getDescendants(node);
        // let temp = [];
        // for (let x = 0; x < descendants.length; x++) {
        //     let actions = descendants[x].actions;
        //     let flag = this.checkColumnExist('View', actions);
        //     if (flag) {
        //         temp.push(descendants[x]);
        //     }
        // }
        // this.checklistSelectionView.isSelected(node) ? this.checklistSelectionView.select(...temp) : this.checklistSelectionView.deselect(...temp);

        // descendants.forEach((child) => this.checklistSelectionView.isSelected(child));
        // this.checkAllParentsSelectionViewColumn(node);
    }

    checkAllParentsSelectionViewColumn(node: any): void {
        let parent: any | null = this.getParentNodeViewColumn(node);
        while (parent) {
            this.checkRootNodeSelectionViewColumn(parent);
            parent = this.getParentNodeViewColumn(parent);
        }
    }

    checkRootNodeSelectionViewColumn(node: any): void {
        const nodeSelected = this.checklistSelectionView.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('View', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const descAllSelected =
            temp.length > 0 &&
            temp.every((child) => {
                return this.checklistSelectionView.isSelected(child);
            });
        if (nodeSelected && !descAllSelected) {
            this.checklistSelectionView.deselect(node);
        } else if (!nodeSelected && descAllSelected) {
            this.checklistSelectionView.select(node);
        }
    }

    getParentNodeViewColumn(node: any): any | null {
        const currentLevel = node.level;
        if (currentLevel < 1) {
            return null;
        }
        const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
        for (let i = startIndex; i >= 0; i--) {
            const currentNode = this.treeControl.dataNodes[i];
            if (currentNode.level < currentLevel) {
                return currentNode;
            }
        }
        return null;
    }

    checkAllChildrenNodeView(data: any, status: boolean, columnName: string) {
        if (data.children?.length > 0) {
            for (let x = 0; x < data.children.length; x++) {
                let index = this.findActionsIndex(data.children[x].actions, 'View');
                if (data.children[x].actions[index].securityPermissionColumn.name === columnName) {
                    data.children[x].actions[index].allowed = status;
                    if (data.children[x]?.children?.length > 0) {
                        this.checkAllChildrenNodeView(data.children[x], status, columnName);
                    }
                }
            }
        }
    }

    /********************** Modify Column Methods  *************************/
    descendantsAllSelectedModifyColumn(node: any): boolean {
        const descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('Modify', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const descAllSelected =
            temp.length > 0 &&
            temp.every((child) => {
                return this.checklistSelectionModify.isSelected(child);
            });
        return descAllSelected;
    }

    descendantsPartiallySelectedModifyColumn(node: any): boolean {
        var descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('Modify', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const result = temp.some((child) => this.checklistSelectionModify.isSelected(child));
        return result && !this.descendantsAllSelectedModifyColumn(node);
    }

    todoLeafItemSelectionToggleModifyColumn(node: any): void {
        this.checklistSelectionModify.toggle(node);
        // this.checkAllParentsSelectionModifyColumn(node);
    }

    todoItemSelectionToggleModifyColumn(node: any, checkStatus: boolean): void {
        // this.checkAllChildrenNodeModify(node, checkStatus, 'Modify');
        this.checklistSelectionModify.toggle(node);
        // const descendants = this.treeControl.getDescendants(node);
        // let temp = [];
        // for (let x = 0; x < descendants.length; x++) {
        //     let actions = descendants[x].actions;
        //     let flag = this.checkColumnExist('Modify', actions);
        //     if (flag) {
        //         temp.push(descendants[x]);
        //     }
        // }
        // this.checklistSelectionModify.isSelected(node) ? this.checklistSelectionModify.select(...temp) : this.checklistSelectionModify.deselect(...temp);

        // descendants.forEach((child) => this.checklistSelectionModify.isSelected(child));
        // this.checkAllParentsSelectionModifyColumn(node);
    }

    checkAllParentsSelectionModifyColumn(node: any): void {
        let parent: any | null = this.getParentNodeModifyColumn(node);
        while (parent) {
            this.checkRootNodeSelectionModifyColumn(parent);
            parent = this.getParentNodeModifyColumn(parent);
        }
    }

    checkRootNodeSelectionModifyColumn(node: any): void {
        const nodeSelected = this.checklistSelectionModify.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('Modify', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const descAllSelected =
            temp.length > 0 &&
            temp.every((child) => {
                return this.checklistSelectionModify.isSelected(child);
            });
        if (nodeSelected && !descAllSelected) {
            this.checklistSelectionModify.deselect(node);
        } else if (!nodeSelected && descAllSelected) {
            this.checklistSelectionModify.select(node);
        }
    }

    getParentNodeModifyColumn(node: any): any | null {
        const currentLevel = node.level;
        if (currentLevel < 1) {
            return null;
        }
        const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
        for (let i = startIndex; i >= 0; i--) {
            const currentNode = this.treeControl.dataNodes[i];
            if (currentNode.level < currentLevel) {
                return currentNode;
            }
        }
        return null;
    }

    checkAllChildrenNodeModify(data: any, status: boolean, columnName: string) {
        if (data.children?.length > 0) {
            for (let x = 0; x < data.children.length; x++) {
                let index = this.findActionsIndex(data.children[x].actions, 'Modify');
                if (index >= 0) {
                    if (data.children[x].actions[index].securityPermissionColumn.name === columnName) {
                        data.children[x].actions[index].allowed = status;
                        if (data.children[x]?.children?.length > 0) {
                            this.checkAllChildrenNodeModify(data.children[x], status, columnName);
                        }
                    }
                }
            }
        }
    }

    /********************** Delete Column Methods  *************************/
    descendantsAllSelectedDeleteColumn(node: any): boolean {
        const descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('Delete', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const descAllSelected =
            temp.length > 0 &&
            temp.every((child) => {
                return this.checkListSelectionDelete.isSelected(child);
            });
        return descAllSelected;
    }

    descendantsPartiallySelectedDeleteColumn(node: any): boolean {
        var descendants = this.treeControl.getDescendants(node);
        const result = descendants.some((child) => this.checkListSelectionDelete.isSelected(child));
        return result && !this.descendantsAllSelectedDeleteColumn(node);
    }

    todoLeafItemSelectionToggleDeleteColumn(node: any): void {
        this.checkListSelectionDelete.toggle(node);
        // this.checkAllParentsSelectionDeleteColumn(node);
    }

    todoItemSelectionToggleDeleteColumn(node: any, checkStatus: boolean): void {
        // this.checkAllChildrenNodeDelete(node, checkStatus, 'Delete');
        this.checkListSelectionDelete.toggle(node);
        // const descendants = this.treeControl.getDescendants(node);
        // let temp = [];
        // for (let x = 0; x < descendants.length; x++) {
        //     let actions = descendants[x].actions;
        //     let flag = this.checkColumnExist('Delete', actions);
        //     if (flag) {
        //         temp.push(descendants[x]);
        //     }
        // }
        // this.checkListSelectionDelete.isSelected(node) ? this.checkListSelectionDelete.select(...temp) : this.checkListSelectionDelete.deselect(...temp);

        // temp.forEach((child) => this.checkListSelectionDelete.isSelected(child));
        // this.checkAllParentsSelectionDeleteColumn(node);
    }

    checkAllParentsSelectionDeleteColumn(node: any): void {
        let parent: any | null = this.getParentNodeDeleteColumn(node);
        while (parent) {
            this.checkRootNodeSelectionDeleteColumn(parent);
            parent = this.getParentNodeDeleteColumn(parent);
        }
        ``;
    }

    checkRootNodeSelectionDeleteColumn(node: any): void {
        const nodeSelected = this.checkListSelectionDelete.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        let temp = [];
        for (let x = 0; x < descendants.length; x++) {
            let actions = descendants[x].actions;
            let flag = this.checkColumnExist('Delete', actions);
            if (flag) {
                temp.push(descendants[x]);
            }
        }
        const descAllSelected =
            temp.length > 0 &&
            temp.every((child) => {
                return this.checkListSelectionDelete.isSelected(child);
            });
        if (nodeSelected && !descAllSelected) {
            this.checkListSelectionDelete.deselect(node);
        } else if (!nodeSelected && descAllSelected) {
            this.checkListSelectionDelete.select(node);
        }
    }

    getParentNodeDeleteColumn(node: any): any | null {
        const currentLevel = node.level;
        if (currentLevel < 1) {
            return null;
        }
        const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
        for (let i = startIndex; i >= 0; i--) {
            const currentNode = this.treeControl.dataNodes[i];
            if (currentNode.level < currentLevel) {
                return currentNode;
            }
        }
        return null;
    }

    checkAllChildrenNodeDelete(data: any, status: boolean, columnName: string) {
        if (data.children?.length > 0) {
            for (let x = 0; x < data.children.length; x++) {
                let index = this.findActionsIndex(data.children[x].actions, 'Delete');
                if (index >= 0) {
                    if (data.children[x].actions[index].securityPermissionColumn.name === columnName) {
                        data.children[x].actions[index].allowed = status;
                        if (data.children[x]?.children?.length > 0) {
                            this.checkAllChildrenNodeDelete(data.children[x], status, columnName);
                        }
                    }
                }
            }
        }
    }

    //helper method tot find the actions index
    findActionsIndex(actions: any[], columnName) {
        let index;
        for (let x = 0; x < actions.length; x++) {
            if (actions[x].securityPermissionColumn.name === columnName) {
                index = x;
                break;
            }
        }
        return index;
    }

    flattenChildren(arr) {
        let result = [];
        function recursiveFlatten(item) {
            if (item.children && item.children.length > 0) {
                item.children.forEach((child) => {
                    result.push(child);
                    recursiveFlatten(child);
                });
                item.children = [];
            }
        }

        arr.forEach((item) => {
            result.push(item);
            recursiveFlatten(item);
        });
        return result;
    }

    onKeyPress(event: KeyboardEvent) {
        this.customValidator.validateKeyPress(event);
    }

    ngOnDestroy() {
        this.permissionTreeData = [];
        this.securityRoleSubscription.unsubscribe();
    }
}
